import React, { Component } from "react";
import * as PIXI from "pixi.js";
import UIManager from "../../core/components/ui/UiBuilder";
import { withPixiApp } from "@inlet/react-pixi";
import { GJIStore } from "../../gamestore/IStore";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withGameControlComponentConfiguration from "./configuration/withgameControlComponentConfiguration";
import { isMobile } from "react-device-detect";
import { configGame, constant } from "../../data/config";
//import { Scrollbox } from 'pixi-scrollbox'



interface IStore {
    [x: string]: any;
}
interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class GameControlComponent extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected displayUI: any;
    protected gameControlComponent: any;
    protected gameControlComponentContainer: any;
    protected scope: any;
    protected ui_mode: string;
    protected gameControlComponentList: Array<any>

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.gameControlComponent = React.createRef();
        this.gameControlComponentContainer = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en"
        }

        if (isMobile) {
            this.ui_mode = "mobile"
        } else {
            this.ui_mode = "desktop"
        }
        //reel,row
        this.gameControlComponentList = []
        this.displayUI = this.props.data.COMPONENTS[0].child.filter(this.checkUiMode.bind(this));
    }

    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    bindUI() {

        if ((window as any).GAME_INFO.jurisdiction == "uk" || (window as any).GAME_INFO.jurisdiction == "nl" || (window as any).GAME_INFO.jurisdiction == "de") {
            UIManager.getRef("Control_Autoplay_Container").visible = false;
            UIManager.getRef("Control_Buy_Feature").visible = false;
        }
        if (!this.props.disableBuyIn) {
            UIManager.getRef("Control_Buy_Feature").visible = true;
        } else {
            UIManager.getRef("Control_Buy_Feature").visible = false;
        }
        this.addScrollBar();
    }

    addScrollBar() {
        let gameControlContent: any = UIManager.getRef("gameControlContent")
        let gameControlScrollComponent: any = UIManager.getRef("gameControlScrollComponent")

        const Scrollbox = require('pixi-scrollbox').Scrollbox
        const scrollbox = new Scrollbox({ boxWidth: 1300, boxHeight: 700 })

        scrollbox.x = 200;
        scrollbox.y = 200;
        gameControlScrollComponent && gameControlScrollComponent.addChild(scrollbox)

        // add a sprite to the scrollbox's content
        const sprite = scrollbox.content.addChild(new PIXI.Sprite(PIXI.Texture.WHITE))
        sprite.width = 1300
        sprite.height = 700
        sprite.tint = 0x131313

        scrollbox.dragScroll = true;
        scrollbox.overflowX = "none";
        // force an update of the scrollbox's calculations after updating the children

        scrollbox.content.addChild(gameControlContent);
        // add the viewport to the stage
        scrollbox.update()

    }


    componentDidMount() {
        this.bindUI();

    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        return true;
    }
    render() {

        return (<UIManager id={"gameControlComponent"} name={"gameControlComponent"} type={"Container"}
            ref={i => this.gameControlComponent = i}
            x={0} y={0}>
            {
                this.displayUI && this.displayUI.map((i: any) =>
                    <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                        id={i.id} {...i} app={this.app} />)
            }
        </UIManager>)
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'applicationState' | 'behaviourState'>): IStateToProps =>
    ({
        disableBuyIn: state.behaviourState.disableBuyIn,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({

    }))(withGameControlComponentConfiguration(GameControlComponent)));